export default "__VITE_ASSET__CKwY_nFR__"